// extracted by mini-css-extract-plugin
export var root = "H_vG";
export var wrapper = "H_qk";
export var image = "H_vH d_w d_y d_W";
export var imageWithHeight = "H_vJ";
export var crop = "H_vK";
export var round = "H_vL";
export var fixedHeight = "H_vM";